import { render, staticRenderFns } from "./CommodityPurchaseLayout.vue?vue&type=template&id=253e55bc&scoped=true"
import script from "./CommodityPurchaseLayout.vue?vue&type=script&lang=js"
export * from "./CommodityPurchaseLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253e55bc",
  null
  
)

export default component.exports